import getters from './getters'
import mutations from './mutations'
import actions from './actions'

const state = {
    isFeatureEnabled: false
}

export {
  state,
  getters,
  mutations,
  actions
}
  